import React from 'react';
import type { TableSegment } from './translation.types';

interface InlineTableProps {
  segment: TableSegment;
  nodeId: string;
  onParameterChanged?: (nodeId: string, paramName: string, value: unknown) => void;
}

export const InlineTable: React.FC<InlineTableProps> = ({
  segment,
  nodeId,
  onParameterChanged,
}) => {
  const isGradientLike = segment.columns.some((col) => col.key.startsWith('Pump'));

  const handleCellChange = (rowIndex: number, colKey: string, value: string) => {
    const updatedRows = segment.rows.map((row, i) => {
      if (i !== rowIndex) return row;
      return { ...row, [colKey]: { ...row[colKey], value } };
    });
    onParameterChanged?.(nodeId, segment.paramName, updatedRows);
  };

  return (
    <div className="inline-table-wrapper">
      <table className={`inline-table ${isGradientLike ? 'inline-table-gradient' : ''}`}>
        <thead>
          <tr>
            {segment.columns.map((col, colIdx) => (
              <th key={`${col.key}-${colIdx}`}>
                {col.label}
                {col.unit ? ` (${col.unit})` : ''}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {segment.rows.map((row, rowIdx) => (
            <tr key={rowIdx}>
              {segment.columns.map((col, colIdx) => (
                <td key={`${rowIdx}-${col.key}-${colIdx}`}>
                  <input
                    type={row[col.key]?.fieldType === 'number' ? 'number' : 'text'}
                    value={String(row[col.key]?.value ?? '')}
                    disabled={segment.disabled}
                    onChange={(e) => handleCellChange(rowIdx, col.key, e.target.value)}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
